import unauthenticatedFetch from 'services/rest/unauthenticatedFetch';
import { Headers } from 'shared/constants/headers';
import { z } from 'zod';

export interface AccountLookupData {
  emailAddress: string;
  aToken?: string;
}

// Define schema that matches AccountLookupResponse
const accountLookupResponseSchema = z.object({
  identityId: z.string().optional(),
  allow1FA: z.boolean().optional(),
  message: z.string().optional(),
  errorCode: z
    .union([z.string(), z.number()])
    .transform((value) => Number(value))
    .optional(),
  title: z.string().optional(),
});

// Extract type from schema
export type AccountLookupResponse = z.infer<typeof accountLookupResponseSchema>;

export default async function fetchAccountLookup(
  lambdaUrl: string,
  data: AccountLookupData,
  headers: Headers,
) {
  const response = await unauthenticatedFetch(`${lambdaUrl}/account-lookup`, {
    method: 'POST',
    cache: 'no-cache',
    body: JSON.stringify(data),
    headers,
  });

  const result: unknown = await response.json();
  return accountLookupResponseSchema.parse(result);
}
